var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "mku-menu-group" }, [
    _vm.title
      ? _c("div", { staticClass: "mku-menu-group__title" }, [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("ul", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }